import { faCode, faShieldAlt } from "@fortawesome/free-solid-svg-icons";
import { MotionFrame } from "../utilities/framer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LeftFrame } from "../utilities/service-framer";
import SlideRight from "../utilities/right-shift";

export const StackObject = ({
    stack
}) => {
    return (
        <MotionFrame>
            <div className="stack glassy-effect">
                <div className="top-ico">
                    <FontAwesomeIcon icon={faCode} color="#082858ff" />
                </div>
                <div className="stack-nm">{stack}</div>
            </div>
        </MotionFrame>
    );
}

export const ComplianceObject  = ({stack}) => {
    return (
        <SlideRight>
            <div className="sm-stack glassy-effect">
                <div className="top-ico">
                    <FontAwesomeIcon icon={faShieldAlt} color="#d76910ff" />
                </div>
                <div className="stack-nm">{stack}</div>
            </div>
        </SlideRight>
    );
}